import React from "react";

const Topheader = () => {
  return (
    <>
      <section className="top-header">
        <div className="container">
          <div className="space-between-block">
            <div className="w-layout-hflex horizontal-left-center-40px-gap">
              <div className="w-layout-hflex icon-list-10px-gap">
                <img
                  loading="lazy"
                  src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5db3e0574c7e90b98bbf1_%EF%81%BC-1.png"
                  alt=""
                  className="image-15px-contain"
                />
                <a href="mailto:support@uaepass.ae">
                  <p className="text-white">info@eristarug.com</p>
                </a>
              </div>
              <div className="w-layout-hflex icon-list-10px-gap">
                <img
                  loading="lazy"
                  src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5db3ed2fc7e76d97c57d1_%EF%81%BC.png"
                  alt=""
                  className="image-15px-contain"
                />
                <a href="tel:+256709438944">
                  <p className="text-white">+256 709 438 944</p>
                </a>
                <a href="">
                  <p className="text-white">/</p>
                </a>
                <a href="tel:+256764070076">
                  <p className="text-white">+256 764 070 076</p>
                </a>
              </div>
            </div>
            <div className="w-layout-hflex icon-list-10px-gap hide-in-portrait">
              <img
                loading="lazy"
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5db3e17291d14f27d4f78_%EF%81%BC-2.png"
                alt=""
                className="image-15px-contain"
              />
              <p className="text-white">Southpoint Kabalagala</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Topheader;
